// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/google_authenticator/google_authenticator.proto" (package "mlmbox.client.google_authenticator", syntax proto3)
// tslint:disable
import { GoogleAuthenticator_VerifiedCode_Response } from "../../types/google_authenticator.ts";
import { GoogleAuthenticator_VerifiedCode_Request } from "../../types/google_authenticator.ts";
import { GoogleAuthenticator_SecretCode } from "../../types/google_authenticator.ts";
import { GoogleAuthenticator as GoogleAuthenticator$ } from "../../types/google_authenticator.ts";
import { Empty } from "../../../google/protobuf/empty.ts";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
/**
 * @generated ServiceType for protobuf service mlmbox.client.google_authenticator.GoogleAuthenticator
 */
export const GoogleAuthenticator = new ServiceType("mlmbox.client.google_authenticator.GoogleAuthenticator", [
    { name: "Info", options: {}, I: Empty, O: GoogleAuthenticator$ },
    { name: "Generate", options: {}, I: Empty, O: GoogleAuthenticator_SecretCode },
    { name: "Activate", options: {}, I: GoogleAuthenticator_VerifiedCode_Request, O: GoogleAuthenticator_VerifiedCode_Response },
    { name: "Deactivate", options: {}, I: GoogleAuthenticator_VerifiedCode_Request, O: GoogleAuthenticator_VerifiedCode_Response }
]);
